import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);

//newMenu 导航菜单选中
//menus 菜单权限
//seekResult  站点树选中站点名称
//seekSiteId  站点树选中站点id
//seekType 站点列表 站点类型 搜索
//siteParti  现场数据选中站点id,导航栏搜索选中id  用于查看详情    大数据对比站点id
//siteType  现场数据选中站点类型  用于查看详情
//companyContrast     大数据对比公司id
//groupContrast     大数据对比分组id
//mapCataNum    地图站点类型数量
let userInfo =
  localStorage.getItem("userInfo") == null
    ? ""
    : JSON.parse(localStorage.getItem("userInfo"));
// userInfo.admin=0;
// userInfo.menus='CONSOLE';
// userInfo.perms='MO:TRACE';
export default new vuex.Store({
  state: {
    token: "",
    companyId: userInfo != "" ? userInfo.companyId : "",
    userId: userInfo != "" ? userInfo.id : "",
    newMenu: "",
    seekResult: [],
    seekSiteId: [],
    seekType: "",
    siteParti: sessionStorage.getItem("siteParti"),
    siteType: sessionStorage.getItem("siteType"),
    siteRtuCode: "",
    siteComparison: sessionStorage.getItem("siteComparison"),
    companyContrast: "",
    groupContrast: "",
    mapCataNum: [],
    sevCrtuCode: "",
    mesComId: "",
    mapSiteType: "",
    // companyId: localStorage.getItem("companyId") || "",
    siteCount: localStorage.getItem("siteCount") || ""
  },
  mutations: {
    setCompanyId(state, data) {
      state.companyId = data.companyId;
    },
    setSiteCount(state, data) {
      state.siteCount = data.siteCount;
    }
  },
  getters: {
    companyId: state => state.companyId,
    siteCount: state => state.siteCount,
    checkMenus: state => menus => {
      let userInfo =
        localStorage.getItem("userInfo") == null
          ? ""
          : JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo) {
        return false;
      } else if (userInfo.admin === 1) {
        return true;
      } else {
        if (!userInfo.menus) {
          return false;
        } else {
          return userInfo.menus.split(",").includes(menus);
        }
      }
    },
    checkPerm: state => perm => {
      let userInfo =
        localStorage.getItem("userInfo") == null
          ? ""
          : JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo) {
        return false;
      } else if (userInfo.admin === 1) {
        return true;
      } else {
        if (!userInfo.perms) {
          return false;
        } else {
          return userInfo.perms.split(",").includes(perm);
        }
      }
    }
  }
});
